





























import { Component, Prop, Vue } from 'vue-property-decorator';
import Magazine from '../../models/Magazine';
import { namespace } from 'vuex-class';

const MagazineStore = namespace('magazine');

@Component({})
export default class ThumbnailPageComponent extends Vue {

    @Prop({ default: 0 })
    public page!: number;

    @Prop({ default: () => new Magazine() })
    public magazine!: Magazine;

    @Prop({ default: false })
    public splitMode!: boolean;

    @Prop({ default: false })
    public isNextPage!: boolean

    @Prop({ default: false })
    public isLeftPage!: boolean

    @Prop({ default: false })
    public isHighlightedPage!: boolean

    @Prop({ default: false })
    public isLastPage!: boolean

    @MagazineStore.Action('getMagazineThumbnail')
    private getMagazineThumbnail!: (payload: { publicationId: string, page: number }) => string;

    public thumbnailSrc: string = '';

    public async onIntersect(entries: any, observer: any, isIntersecting: any) {
        if (isIntersecting) {
            this.thumbnailSrc = await this.getMagazineThumbnail({
                publicationId: this.magazine.publicationId,
                page: this.page
            });
        }
    }

    public openPage() {
        this.$emit('openPage', this.page);
    }

    /**
     * Check if the images should be centered or aligned to the left / right
     */
    get getPageImageAlignment() {
        if (this.magazine.showSinglePage) {
            return 'center center';
        } else if (this.$vuetify.breakpoint.mdAndUp && (this.splitMode && this.page % 2 !== 0)) {
            return 'right center';
        } else if (this.$vuetify.breakpoint.mdAndUp && (this.splitMode && this.page % 2 === 0)) {
            return 'left center';
        }
        return 'center center';
    }

    /**
     * Check if the page number should be centered or aligned to the left / right
     */
    get getPageNumberAlignment() {
        if (this.magazine.showSinglePage) {
            return [];
        } else if (this.$vuetify.breakpoint.mdAndUp && (this.splitMode && this.page % 2 !== 0)) {
            return ['pl-5'];
        } else if (this.$vuetify.breakpoint.mdAndUp && (this.splitMode && this.page % 2 === 0)) {
            return ['pr-5'];
        }
        return [];
    }

};
